import { v4 as uuidv4 } from "uuid";

import { Entity, GraphNode } from "../../../api";

export const createGraphNodeModel = ({
  entity,
  position,
  value,
}: {
  entity: Entity;
  position: GraphNode["position"];
  value: string;
}): GraphNode => {
  return {
    colorSchema: entity.colorSchema,
    entityName: entity.name,
    entityQualifiedName: entity.qualifiedName,
    icon: entity.icon,
    id: uuidv4(),
    position,
    value,
  };
};
